import script from "./SelectOrTextInputField.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectOrTextInputField.vue?vue&type=script&lang=ts&setup=true"

import "./SelectOrTextInputField.vue?vue&type=style&index=0&id=50aa0de0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50aa0de0"]])

export default __exports__